import { render, staticRenderFns } from "./SignUpWelcome.vue?vue&type=template&id=35cd9d04&scoped=true&"
var script = {}
import style0 from "./SignUpWelcome.vue?vue&type=style&index=0&id=35cd9d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cd9d04",
  null
  
)

export default component.exports